// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';

import type { Action } from '../../../proposition/decorators/withPropositionActions';
import withPropositionActions from '../../../proposition/decorators/withPropositionActions';

type Props = {
  actions: Action[],
  theme: any,
};

function PropositionDetailsActions(props: Props) {
  const { actions, theme } = props;
  return (
    <React.Fragment>
      {actions.length > 0 &&
        actions.map(({ label, onAction, type }) =>
          (
            <RaisedButton
              key={label}
              label={label.toUpperCase()}
              onClick={onAction}
              primary={type === 'SEND' || type === 'MODIFY' || type === 'ACCEPT'}
              secondary={type === 'CANCEL' || type === 'DECLINE'}
              labelStyle={{ color: theme.colors.tertiaryText }}
              backgroundColor={theme.colors.accent}
            />
          ),
      )
    }
    </React.Fragment>
  );
}

export default withPropositionActions(withTheme(PropositionDetailsActions));



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/proposition/PropositionDetailsActions.js